import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Form from "./Form";

const EditProduct = (props: any) => {
  const { handleEdit, isLoading, data } = props;
  const {
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    register,
    setError,
    watch,
    control,
    formState: { errors },
  } = useForm<any>({
    // resolver: yupResolver(createInventoryInfovalidation),
    defaultValues: async () => {
      return {
        hs_code: data?.hs_code,
        description: data?.description,
        name: data?.name,
        is_taxable: data?.is_taxable,
      };
    },
  });

  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleEdit(data, setError))}
          className={tw`px-4`}
        >
          <Form
            control={control}
            register={register}
            errors={errors}
            setValue={setValue}
            watch={watch}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <div className={tw`flex w-full justify-end`}>
            <div className={tw`w-24 flex gap-x-4 items-center`}>
              <Button label="Save" isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>
    </>
  );
};

export default EditProduct;
